import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54cdd040"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
import { onMounted, ref } from "vue";
import { XiaoniuFrontedControllerService } from "../../../generated/services/XiaoniuFrontedControllerService";
import { useRoute } from "vue-router";
import { SysDictDataControllerService } from "../../../generated";
import CourseDesignDetailTop from "@/components/courseDegin/detail/CourseDesignDetailTop.vue";
import CourseDesignDetailContent from "@/components/courseDegin/detail/CourseDesignDetailContent.vue";
import { useLoginUserStore } from "@/store/loginUser";
import CourseDesignDetailRight from "@/components/courseDegin/detail/CourseDesignDetailRight.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetail',
  setup(__props) {
    const dicType = ref("project_type");
    const dictList = ref([]);
    const route = useRoute();
    const courseDesign = ref({});
    /**
     * 获取课设详情
     */
    const getCourseDetail = async () => {
      const id = Number(route.params.id);
      const res = await XiaoniuFrontedControllerService.getCourseDetail(id);
      courseDesign.value = res.data;
    };
    const getSysDicType = () => {
      //获取字典数据
      SysDictDataControllerService.dictTypeUsingGet(dicType.value).then(res => {
        if (res.code === 200) {
          dictList.value = res.data;
        }
      });
    };
    const homeworkViewCount = ref(0);
    const homeworkBuyCount = ref(0);
    const useloginUser = useLoginUserStore();
    const homeworkTopFiveList = ref([]);
    //添加浏览量
    const putHomeworkView = async () => {
      const homeworkId = Number(route.params.id);
      if (useloginUser.isLogin) {
        await XiaoniuFrontedControllerService.addHomeworkViewUsingPost(homeworkId);
      }
      await getHomeworkViewCount();
    };
    //获取浏览量
    const getHomeworkViewCount = async () => {
      const homeworkId = Number(route.params.id);
      const res = await XiaoniuFrontedControllerService.getHomeworkViewUsingPost(homeworkId);
      homeworkViewCount.value = res.data;
    };
    //获取购买量
    const getHomeworkBuyCount = async () => {
      const homeworkId = Number(route.params.id);
      const res = await XiaoniuFrontedControllerService.getHomeworkBuyCountUsingPost(homeworkId);
      homeworkBuyCount.value = res.data;
    };
    //获取项目排行榜
    const getHomeworkTopFive = async () => {
      const res = await XiaoniuFrontedControllerService.topFiveHomeworkUsingPost();
      if (res.code === 200) {
        homeworkTopFiveList.value = res.data;
      }
    };
    onMounted(() => {
      getCourseDetail();
      getSysDicType();
      putHomeworkView();
      getHomeworkBuyCount();
      getHomeworkTopFive();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 24,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(CourseDesignDetailTop, {
            "project-detail": courseDesign.value,
            "dict-list": dictList.value,
            "homework-view-count": homeworkViewCount.value,
            "homework-buy-count": homeworkBuyCount.value
          }, null, 8, ["project-detail", "dict-list", "homework-view-count", "homework-buy-count"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 30
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 16,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(CourseDesignDetailContent, {
            "course-detail": courseDesign.value
          }, null, 8, ["course-detail"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 8
        }, {
          default: _withCtx(() => [_createVNode(CourseDesignDetailRight, {
            "project-top-five-list": homeworkTopFiveList.value
          }, null, 8, ["project-top-five-list"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});